export const DEFAULT_DELETE_ICON_COLOR = '#EB5757';
